import { render, staticRenderFns } from "./MyServiceProviders.vue?vue&type=template&id=64ed599c&"
import script from "./MyServiceProviders.vue?vue&type=script&lang=js&"
export * from "./MyServiceProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports